export const DEFAULT_ERROR_MESSAGE =
	'You will need to contact the assigned claim representative for your claim details. ' +
	"If you do not have the claim representative's contact information, you may contact our Claim Resource Center at 844.267.0864 " +
	"for assistance in obtaining your claim representative's contact information.";

export const FIRST_PARTY_ERROR_MESSAGE =
	'For claim updates involving the Auto-Owners policyholder or covered family member, the policyholder should ' +
	'sign in to %s to view claim-specific information.';

export const WRONG_EXPOSURE_ERROR_MESSAGE = 'Claim updates are not applicable for this claim.';

export const WRONG_EXPOSURE_ERROR_MESSAGE_EXTRA_TEXT = ' Contact %s at %s for details.';
